import { MdClose, MdCheckCircle, MdCancel, MdAutoAwesome } from 'react-icons/md';

export default function GuidelineReviewModal({ open, loading, error, result, original, onUseCorrected, onUseOriginal, onPublishWithoutReview, onRetry, onClose }) {
  if (!open) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 720, borderRadius: 16, overflow: 'hidden' }}>
        <div style={{ background: '#F0F9FF', padding: '18px 24px', borderBottom: '1px solid #BAE6FD', display: 'flex', alignItems: 'center', gap: 12 }}>
          <div style={{ width: 38, height: 38, borderRadius: '50%', background: '#E0F2FE', color: '#0369A1', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 20, flexShrink: 0 }}>
            <MdAutoAwesome />
          </div>
          <div style={{ flex: 1 }}>
            <h3 style={{ margin: 0, fontSize: 17, fontWeight: 700, color: '#0C4A6E' }}>Udayam Guideline Review</h3>
            <p style={{ margin: 0, fontSize: 12.5, color: '#0369A1', marginTop: 2 }}>
              AI-checked against the 5 Udayam Telugu news writing guideline sections.
            </p>
          </div>
          <button className="modal-close" onClick={onClose}><MdClose /></button>
        </div>

        <div className="modal-body" style={{ padding: 24, maxHeight: '65vh', overflowY: 'auto' }}>
          {loading && (
            <div style={{ textAlign: 'center', padding: '40px 0', color: '#475569', fontSize: 14 }}>
              ⏳ Reviewing against Udayam guidelines...
            </div>
          )}

          {!loading && error && (
            <div style={{ background: '#FEF2F2', border: '1px solid #FECACA', borderRadius: 10, padding: 16, color: '#991B1B', fontSize: 13.5 }}>
              <strong>AI review failed:</strong> {error}
            </div>
          )}

          {!loading && !error && result && (
            <>
              <div style={{ marginBottom: 20 }}>
                <div style={{ fontSize: 12, fontWeight: 700, color: '#64748B', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 10 }}>
                  Checklist (5 sections)
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                  {result.checklist.map((item) => (
                    <div key={item.section} style={{
                      display: 'flex', alignItems: 'flex-start', gap: 10,
                      background: item.passed ? '#F0FDF4' : '#FFFBEB',
                      border: `1px solid ${item.passed ? '#BBF7D0' : '#FDE68A'}`,
                      borderRadius: 8, padding: '10px 12px'
                    }}>
                      {item.passed
                        ? <MdCheckCircle color="#16A34A" size={18} style={{ flexShrink: 0, marginTop: 1 }} />
                        : <MdCancel color="#D97706" size={18} style={{ flexShrink: 0, marginTop: 1 }} />}
                      <div>
                        <div style={{ fontSize: 13.5, fontWeight: 700, color: item.passed ? '#166534' : '#92400E' }}>{item.section}</div>
                        {item.note && <div style={{ fontSize: 12.5, color: '#57534E', marginTop: 2 }}>{item.note}</div>}
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
                <div style={{ background: '#F8FAFC', border: '1px solid #E2E8F0', borderRadius: 10, padding: 14 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                    <span style={{ fontSize: 11, fontWeight: 700, color: '#64748B', textTransform: 'uppercase', letterSpacing: 0.5 }}>Original</span>
                    <span style={{ fontSize: 11, color: '#64748B' }}>{(original.summary || '').length}/400 chars</span>
                  </div>
                  <div style={{ fontSize: 13.5, fontWeight: 700, color: '#0F172A', marginBottom: 6, lineHeight: 1.4 }}>{original.title}</div>
                  <div style={{ fontSize: 13, color: '#334155', lineHeight: 1.5, whiteSpace: 'pre-wrap' }}>{original.summary}</div>
                </div>
                <div style={{ background: '#F0FDF4', border: '1px solid #BBF7D0', borderRadius: 10, padding: 14 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                    <span style={{ fontSize: 11, fontWeight: 700, color: '#166534', textTransform: 'uppercase', letterSpacing: 0.5 }}>Corrected</span>
                    <span style={{ fontSize: 11, color: '#166534' }}>{(result.corrected.body || '').length}/400 chars</span>
                  </div>
                  <div style={{ fontSize: 13.5, fontWeight: 700, color: '#0F172A', marginBottom: 6, lineHeight: 1.4 }}>{result.corrected.title}</div>
                  <div style={{ fontSize: 13, color: '#334155', lineHeight: 1.5, whiteSpace: 'pre-wrap' }}>{result.corrected.body}</div>
                </div>
              </div>
            </>
          )}
        </div>

        <div className="modal-footer" style={{ padding: '16px 24px', background: '#F8FAFC', borderTop: '1px solid #E2E8F0', display: 'flex', gap: 10, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
          {!loading && error && (
            <>
              <button className="btn btn-ghost" onClick={onClose}>Cancel</button>
              <button className="btn btn-ghost" onClick={onRetry}>Retry Review</button>
              <button className="btn btn-primary" onClick={onPublishWithoutReview}>Publish Without Review</button>
            </>
          )}
          {!loading && !error && result && (
            <>
              <button className="btn btn-ghost" onClick={onClose}>Edit Manually</button>
              <button className="btn btn-outline-red" onClick={onUseOriginal}>Keep Original &amp; Publish</button>
              <button className="btn btn-primary" onClick={onUseCorrected}>Use Corrected &amp; Publish</button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
